<template>
<div class="popCommission" v-if="centerDialogVisible">
    <el-dialog title="佣金明细" :visible.sync="centerDialogVisible" width="720px" center>
        <div class="user">
            <div class="box">
                <span>订单号：</span>
                <span>{{popData.orderView.orderno}}</span>
            </div>
            <div class="box">
                <span>购买人：</span>
                <img class="img"  :src="popData.orderView.customericonurl" alt="" v-if="popData.orderView.customericonurl">
                <span>{{popData.orderView.customername}}</span>
            </div>
            <div class="box">
                <span>支付金额：</span>
                <span>￥{{popData.orderView.finalpaymoney}}</span>
            </div>
            <div class="box">
                <span>订单时间：</span>
                <span>{{popData.orderView.datetime}}</span>
            </div>
        </div>
        <el-table :data="popData.dataList">
            <el-table-column width="80" property="distier" label="分销层级"></el-table-column>
            <el-table-column property="name" label="分销人">
                <template slot-scope="scope">
                    <div class="imageText">
                        <img class="img" :src="scope.row.headimage" alt="" v-if="scope.row.headimage">
                        <span>{{scope.row.customername}}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column property="brokerage" label="返现金额" >
                <template slot-scope="scope">￥{{scope.row.brokerage}}</template>
            </el-table-column>
            <el-table-column width="180" property="datetime" label="返现时间" label-class-name="tr"></el-table-column>
        </el-table>
    </el-dialog>
</div>
</template>

<script>
export default {
    name: 'popCommission',
    data() {
        return {
            centerDialogVisible: false
        }
    },
    props: ['popData'],
    mounted() {
    },
    methods: {
        open() {
            this.centerDialogVisible = true
        }
    },
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.popCommission {
    .user{
        font-size: 14px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-wrap: wrap;
        .box{
            width: 50%;
            height: 50px;
            display: flex;
            align-items: center;
            justify-content: flex-start;
        }
    }
    .img{
        width: 50px;
        height: 50px;
        border-radius: 50%;
        margin-right: 10px;
    }
    .imageText{
        display: flex;
        align-items: center;
    }
}
</style>
